import { parseTelegramLink, parseWhatsappLink } from '../utils';

const defaultWindowParams =
  'width=800px,height=700px,menubar=no,toolbar=no,resizable=yes,scrollbars=yes';

const getUrl = (value, socialLink) =>
  !/^(http(s?)):/.test(value) ? `${socialLink}${value}` : value;

export const openLink = (event, url, target, params) => {
  if (event.nativeEvent.target.nodeName !== 'A') {
    event.preventDefault();

    window.open(
      !/^(http(s?)|tel|mailto|SMS|skype):/.test(url) ? `https://${url}` : url,
      target,
      params
    );
  }
};

export const redirect = (event, url) => window.top.open(url, '_top');
export const openInNewTab = (event, url) => openLink(event, url, '_blank');

const emailRegExp = /\S+@\S+\.\S+/;

export const actions = {
  openLink,
  redirect,
  openInNewTab,
  email: (e, value) =>
    value && emailRegExp.test(value) && openLink(e, `mailto:${value}`, '_self'),
  call: (e, value) => value && openLink(e, `tel:${value}`, '_self'),
  callSkype: (e, value) => value && openLink(e, `skype:${value}?call`, '_self'),
  sendSMS: (e, value) => value && openLink(e, `SMS:${value}`, '_self'),

  chatWhatsapp: (e, value) =>
    value &&
    openLink(e, parseWhatsappLink(value), 'whatsapp', defaultWindowParams),
  chatTelegram: (e, value) =>
    value &&
    openLink(e, parseTelegramLink(value), 'telegram', defaultWindowParams),
  chatSkype: (e, value) => value && openLink(e, `skype:${value}?chat`, '_self'),

  followFacebook: (e, value) =>
    value && openInNewTab(e, getUrl(value, 'https://www.facebook.com/')),
  followInstagram: (e, value) =>
    value && openInNewTab(e, getUrl(value, 'https://www.instagram.com/')),
  followLinkedIn: (e, value) =>
    value && openInNewTab(e, getUrl(value, 'https://www.linkedin.com/in/')),
  followPinterest: (e, value) =>
    value && openInNewTab(e, getUrl(value, 'https://www.pinterest.ru/')),
  followTikTok: (e, value) =>
    value && openInNewTab(e, getUrl(value, 'https://www.tiktok.com/@')),
  followX: (e, value) =>
    value && openInNewTab(e, getUrl(value, 'https://x.com/')),
  followYoutube: (e, value) =>
    value && openInNewTab(e, getUrl(value, 'https://www.youtube.com/c/')),

  shareFacebook: (e, value) =>
    value &&
    openLink(
      e,
      `https://www.facebook.com/sharer.php?u=${value}`,
      'facebook',
      defaultWindowParams
    ),
  shareLinkedIn: (e, value) =>
    value &&
    openLink(
      e,
      `https://www.linkedin.com/sharing/share-offsite/?url=${value}`,
      'telegram',
      defaultWindowParams
    ),
  shareX: (e, value) =>
    value &&
    openLink(
      e,
      `https://x.com/share?url=${value}`,
      'telegram',
      defaultWindowParams
    ),
  sharePinterest: (e, value) =>
    value &&
    openLink(
      e,
      `https://pinterest.com/pin/create/link/?url=${value}`,
      'telegram',
      defaultWindowParams
    ),
  print: () => window.print(),
  scrollToElement: (e, value) => {
    let elem;
    if (value.startsWith('#') || value.startsWith('.')) {
      elem = document.querySelector(value);
    } else {
      elem = document.getElementById(value);
      if (!elem) elem = document.getElementsByClassName(value)[0];
    }
    elem?.scrollIntoView();
  }
};
